import React from 'react';
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import {
  DISCOVERY_FINANCE_ROUTE,
  FINANCE_MANAGEMENT_MODULE_ROUTE,
  JFT_FINANCE_ROUTE,
  MGMENT_FINANCE_ROUTE,
} from '../../routes/routes';
import ManagementAppFinanceScreen from './ManagementAppFinance/ManagementAppFinanceScreen';
import DiscoveryAppFinanceScreen from './DiscoveryAppFinance/DiscoveryAppFinanceScreen';
import JftFinance from './JFTFinance/JftFinance';
import useScopes from '../../hooks/useScopes';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

const DoNotHaveAccess = () => {
  return (
    <Box
      fontFamily={'Rubik'}
      width={'100%'}
      minHeight={400}
      display="flex"
      justifyContent={'center'}
      alignItems="center">
      <Box maxWidth={500} fontSize={16} textAlign={'center'}>
        <Box mb={1}>You do not have access to this feature</Box>
        <Box fontSize={12}>
          NOTE: You are seeing this screen because you did not complete your KYC
          or you do not have permission to view this screen or You are not a
          PLATINUM member
        </Box>
      </Box>
    </Box>
  );
};

function FinanceManagementScreen() {
  const classes = useStyles();
  const { access } = useScopes();

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  return (
    <Container className={classes.overAll}>
      <Box display="flex" flex={1} justifyContent="center" alignItems="center">
        <Box flex={1} flexGrow={1}>
          <Typography variant="h4" component="div">
            <Box fontWeight="fontWeightMedium">Finance Management</Box>
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Managing Finance
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flex={10}>
        <Box flex={9} pt={4}>
          <Switch>
            <PrivateRoute
              exact
              path={[MGMENT_FINANCE_ROUTE, FINANCE_MANAGEMENT_MODULE_ROUTE]}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['user:management:readWrite'],
                })
                  ? ManagementAppFinanceScreen
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={DISCOVERY_FINANCE_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['finance:discovery:readWrite'],
                })
                  ? DiscoveryAppFinanceScreen
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={JFT_FINANCE_ROUTE}
              component={JftFinance}
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}

export default FinanceManagementScreen;
